'use client';

import { HeroSectionContainer } from '@/components/hero-section-container';
import {
    ParallaxContainer,
    ParallaxImages,
    ParallaxLayer,
    ParallaxOverlay,
} from '@/components/parallax';
import { useImageLayer } from '@/hooks/use-image-layers';

import { Heading } from './components/heading';
import { Subheading } from './components/subheading';
import { IMAGES } from './image-data.gen';

export const HeroSection = () => {
    const { imagesBack, imagesFront } = useImageLayer({
        images: IMAGES,
    });

    return (
        <HeroSectionContainer>
            <ParallaxContainer className="h-[200lvh]">
                <ParallaxImages
                    images={imagesBack}
                    back
                />

                <ParallaxLayer
                    className="flex h-lvh items-center justify-center"
                    parallax={'-90svh'}
                >
                    <Heading />
                </ParallaxLayer>
                <ParallaxOverlay />
                <ParallaxLayer
                    className="h-lvh"
                    parallax={'-60lvh'}
                >
                    <Subheading />
                </ParallaxLayer>
                <ParallaxImages images={imagesFront} />
                <ParallaxOverlay />
            </ParallaxContainer>
        </HeroSectionContainer>
    );
};
